export default function IcSubtract({
  fill = '#000',
  className,
}: {
  fill?: string
  className?: string
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="2"
      viewBox="0 0 8 2"
      fill={fill}
      className={className}
    >
      <path
        d="M7 1L1 1"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
